import { memo, useEffect, useState } from "react"
import styles from "./header.module.css"
import { ReactComponent as Logo } from "../../img/logo.svg"
import { Link, useLocation, useNavigate } from "react-router-dom"
import { links, talentsSignInUrl, talentsSignupUrl } from "../shared/constants/constants"

/** Opens an in-app audience route in a new browser tab (respects CRA PUBLIC_URL). */
const openAudienceRoute = (pathname) => {
	const base = (process.env.PUBLIC_URL || "").replace(/\/$/, "")
	const path = pathname.startsWith("/") ? pathname : `/${pathname}`
	window.open(`${window.location.origin}${base}${path}`, "_blank", "noopener,noreferrer")
}

const ChevronIcon = () => (
	<svg className={styles.navChevron} width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden>
		<path d="M2.5 4.5L6 8L9.5 4.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
	</svg>
)

const ExternalIcon = () => (
	<svg width="10" height="10" viewBox="0 0 10 10" fill="none" aria-hidden>
		<path d="M2 8L8 2M8 2H4M8 2V6" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
	</svg>
)

const IconAts = () => (
	<svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden>
		<rect x="2" y="2" width="14" height="3.5" rx="1.5" fill="currentColor" opacity=".25" />
		<rect x="2" y="7.25" width="10" height="3.5" rx="1.5" fill="currentColor" opacity=".6" />
		<rect x="2" y="12.5" width="7" height="3.5" rx="1.5" fill="currentColor" />
	</svg>
)

const IconAnna = () => (
	<svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden>
		<circle cx="9" cy="9" r="7" stroke="currentColor" strokeWidth="1.5" opacity=".3" />
		<circle cx="9" cy="9" r="3.5" fill="currentColor" opacity=".6" />
		<circle cx="9" cy="9" r="1.2" fill="currentColor" />
	</svg>
)

const IconConsult = () => (
	<svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden>
		<circle cx="9" cy="6" r="3" stroke="currentColor" strokeWidth="1.5" />
		<path d="M3 15c0-3.314 2.686-6 6-6s6 2.686 6 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
	</svg>
)

const IconOps = () => (
	<svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden>
		<rect x="2" y="2" width="6" height="6" rx="1.5" stroke="currentColor" strokeWidth="1.5" />
		<rect x="10" y="2" width="6" height="6" rx="1.5" stroke="currentColor" strokeWidth="1.5" opacity=".5" />
		<rect x="2" y="10" width="6" height="6" rx="1.5" stroke="currentColor" strokeWidth="1.5" opacity=".5" />
		<rect x="10" y="10" width="6" height="6" rx="1.5" stroke="currentColor" strokeWidth="1.5" opacity=".25" />
	</svg>
)

const IconPeople = () => (
	<svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden>
		<circle cx="9" cy="4" r="2.8" fill="currentColor" />
		<path d="M9 6.8v2M5 8.8h8M5 8.8v1.6M13 8.8v1.6" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" opacity=".5" />
		<circle cx="5" cy="13" r="2.2" fill="currentColor" opacity=".55" />
		<circle cx="13" cy="13" r="2.2" fill="currentColor" opacity=".55" />
	</svg>
)

const IconVacations = () => (
	<svg width="18" height="18" viewBox="0 0 16 16" fill="none" aria-hidden>
		<rect x="2" y="3" width="12" height="11" rx="1.5" stroke="currentColor" strokeWidth="1.2" />
		<path d="M5 2v2M11 2v2M2 7h12" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
	</svg>
)

const IconCompensation = () => (
	<svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden>
		<rect x="2" y="5.5" width="14" height="7" rx="1.5" fill="currentColor" opacity=".2" />
		<rect x="2" y="5.5" width="14" height="7" rx="1.5" stroke="currentColor" strokeWidth="1.4" opacity=".6" />
		<circle cx="9" cy="9" r="1.8" fill="currentColor" />
	</svg>
)

const IconPerformance = () => (
	<svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden>
		<rect x="2" y="11.5" width="3.5" height="4.5" rx="1" fill="currentColor" opacity=".3" />
		<rect x="7.25" y="8" width="3.5" height="8" rx="1" fill="currentColor" opacity=".6" />
		<rect x="12.5" y="4.5" width="3.5" height="11.5" rx="1" fill="currentColor" />
	</svg>
)

const IconDiscovery = () => (
	<svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden>
		<circle cx="9" cy="9" r="2.2" fill="currentColor" />
		<circle cx="3.5" cy="4.5" r="1.6" fill="currentColor" opacity=".55" />
		<circle cx="14.5" cy="4.5" r="1.6" fill="currentColor" opacity=".55" />
		<circle cx="9" cy="14.5" r="1.6" fill="currentColor" opacity=".55" />
		<path d="M7.3 7.6L4.7 5.5M10.7 7.6L13.3 5.5M9 11.2V12.9" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" opacity=".45" />
	</svg>
)

const IconAnnaRecruiter = () => (
	<svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden>
		<circle cx="7.5" cy="7.5" r="5" fill="currentColor" opacity=".12" />
		<circle cx="7.5" cy="7.5" r="5" stroke="currentColor" strokeWidth="1.4" opacity=".45" />
		<circle cx="7.5" cy="6.2" r="1.8" fill="currentColor" opacity=".8" />
		<path d="M5 10.8a2.5 2.5 0 0 1 5 0Z" fill="currentColor" opacity=".5" />
		<path d="M11.5 11.5L15 15" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
	</svg>
)

const IconAlexScout = () => (
	<svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden>
		<circle cx="7.5" cy="7.5" r="5" fill="currentColor" opacity=".12" />
		<circle cx="7.5" cy="7.5" r="5" stroke="currentColor" strokeWidth="1.4" opacity=".45" />
		<rect x="5.5" y="4.8" width="4" height="5.7" rx=".5" fill="currentColor" opacity=".6" />
		<rect x="6.2" y="5.7" width="1.1" height="1.1" rx=".2" fill="currentColor" opacity=".35" />
		<rect x="7.7" y="5.7" width="1.1" height="1.1" rx=".2" fill="currentColor" opacity=".35" />
		<rect x="6.2" y="7.4" width="1.1" height="1.1" rx=".2" fill="currentColor" opacity=".35" />
		<rect x="7.7" y="7.4" width="1.1" height="1.1" rx=".2" fill="currentColor" opacity=".35" />
		<path d="M11.5 11.5L15 15" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
	</svg>
)

const ChevronRightIcon = () => (
	<svg className={styles.fpChevronRight} width="10" height="10" viewBox="0 0 10 10" fill="none" aria-hidden>
		<path d="M3.5 1.5L6.5 5L3.5 8.5" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
	</svg>
)

const FEATURE_ICONS = {
	ats: IconAts,
	anna: IconAnna,
	consult: IconConsult,
	discovery: IconDiscovery,
	ops: IconOps,
	people: IconPeople,
	vacations: IconVacations,
	compensation: IconCompensation,
	performance: IconPerformance,
	annaRecruiter: IconAnnaRecruiter,
	alexScout: IconAlexScout,
}

const PRODUCT_GROUPS = [
	{
		id: "build-your-team",
		label: "BUILD YOUR TEAM",
		items: [
			{
				id: "recruiting-ats",
				href: "/#ats",
				iconKey: "ats",
				title: "Recruiting & ATS",
				shortDesc: "Everything you need to find, evaluate, and hire the right people.",
			},
			// {
			// 	id: "techcore-network",
			// 	href: "/#network",
			// 	iconKey: "consult",
			// 	title: "Techcore Network",
			// 	shortDesc: "A curated pool of individual talents, agencies, and senior consultants.",
			// },
			{
				id: "ai-talent-sourcing",
				href: "/#ai-sourcing",
				iconKey: "anna",
				title: "AI Talent Sourcing",
				shortDesc: "Anna searches the Techcore Network and surfaces candidates worth hiring.",
			},
			{
				id: "ai-consultant-discovery",
				href: "/#consultants",
				iconKey: "discovery",
				title: "AI Consultant Discovery",
				shortDesc: "Alex finds the right partners and consultants for your needs.",
			},
		],
	},
	{
		id: "run-your-team",
		label: "RUN YOUR TEAM",
		items: [
			{
				id: "people-org",
				href: "/#how-it-works",
				iconKey: "people",
				title: "People & Org",
				shortDesc: "Central directory, org chart, and employee profiles.",
			},
			{
				id: "vacations-leave",
				href: "/#how-it-works",
				iconKey: "vacations",
				title: "Vacations & Leave",
				shortDesc: "Track time off, approvals, and leave balances in one place.",
			},
			{
				id: "compensation",
				href: "/#how-it-works",
				iconKey: "compensation",
				title: "Compensation",
				shortDesc: "Manage salaries, bands, and compensation reviews.",
				badge: "Coming soon",
			},
			{
				id: "performance",
				href: "/#how-it-works",
				iconKey: "performance",
				title: "Performance",
				shortDesc: "Set goals, run reviews, and grow your team intentionally.",
				badge: "Coming soon",
			},
		],
	},
	{
		id: "ai-agents",
		label: "AI AGENTS",
		items: [
			{
				id: "anna-ai-recruiter",
				href: "/#ai-sourcing",
				iconKey: "annaRecruiter",
				title: "Anna · AI Recruiter",
				shortDesc: "Searches the Techcore Network and ranks candidates for you.",
			},
			{
				id: "alex-ai-scout",
				href: "/#consultants",
				iconKey: "alexScout",
				title: "Alex · AI Scout",
				shortDesc: "Finds the right consultants and partners for your business.",
			},
		],
	},
]

const PRODUCT_ITEMS = PRODUCT_GROUPS.flatMap((group) => group.items)

const FeaturesMegaMenu = memo(function FeaturesMegaMenu({ onCloseFeatures }) {
	return (
		<div className={styles.fpSimple}>
			<div className={styles.fpGroupsGrid}>
				{PRODUCT_GROUPS.map((group) => (
					<div key={group.id}>
						<div className={styles.fpGroupLabel}>{group.label}</div>
						<nav className={styles.fpSimpleList} aria-label={group.label}>
							{group.items.map((section) => {
								const IconCmp = FEATURE_ICONS[section.iconKey]
								return (
									<a key={section.id} href={section.href} className={styles.fpSimpleItem} onClick={onCloseFeatures}>
										<span className={`${styles.fpNavIcon} ${styles[`fpIcon${section.iconKey}`]}`}>
											<IconCmp />
										</span>
										<span className={styles.fpNavText}>
											<span className={styles.fpNavTitleRow}>
												<span className={styles.fpNavTitle}>{section.title}</span>
												{section.badge ? <span className={styles.fpSoonBadge}>{section.badge}</span> : null}
											</span>
											<span className={styles.fpNavDesc}>{section.shortDesc}</span>
										</span>
									</a>
								)
							})}
						</nav>
					</div>
				))}
			</div>
			<div className={styles.ndFooter}>
				<span className={styles.ndNetworkPill}>
					<span className={styles.ndNetDot} />
					Techcore Network: a curated pool of individual talents, agencies, and senior consultants.
					{/* 12k+ talents · 340+ agencies · 800+ consultants */}
				</span>
				<Link to="/pricing" className={styles.ndFooterCta} onClick={onCloseFeatures}>
					See pricing →
				</Link>
			</div>
		</div>
	)
})

const scrollDocumentTop = () => {
	window.scrollTo({ top: 0, left: 0, behavior: "auto" })
}

const Header = ({ minimal = false, talents = false, startups = false, hideAudienceNav = false }) => {
	const navigate = useNavigate()
	const { pathname } = useLocation()
	const [featuresOpen, setFeaturesOpen] = useState(false)
	const [mobileOpen, setMobileOpen] = useState(false)

	const handleLogoClick = () => {
		setFeaturesOpen(false)
		setMobileOpen(false)
		if (pathname === "/") {
			scrollDocumentTop()
			return
		}
		navigate("/")
		requestAnimationFrame(() => {
			scrollDocumentTop()
		})
	}

	const handleSignUpClick = () => {
		window.location.href = links.startupsSignUp
	}

	const handleSignInClick = () => {
		window.location.href = `${links.startups}sign-in`
	}

	const handlePricingClick = () => {
		navigate("/pricing")
	}

	const handleProvidersClick = () => {
		openAudienceRoute("/agencies")
	}

	const handleHiringClick = () => {
		openAudienceRoute("/talents")
	}

	const closeFeatures = () => setFeaturesOpen(false)
	const closeMobile = () => setMobileOpen(false)

	useEffect(() => {
		closeMobile()
	}, [pathname])

	useEffect(() => {
		if (!featuresOpen) return
		const onKey = (e) => {
			if (e.key === "Escape") closeFeatures()
		}
		document.addEventListener("keydown", onKey)
		return () => document.removeEventListener("keydown", onKey)
	}, [featuresOpen])

	useEffect(() => {
		if (!mobileOpen) return
		const onKey = (e) => {
			if (e.key === "Escape") closeMobile()
		}
		document.addEventListener("keydown", onKey)
		document.body.style.overflow = "hidden"
		return () => {
			document.removeEventListener("keydown", onKey)
			document.body.style.overflow = ""
		}
	}, [mobileOpen])

	if (minimal) {
		return (
			<div className={styles.header}>
				<div className={styles.leftSide}>
					<Logo onClick={handleLogoClick} />
				</div>
			</div>
		)
	}

	if (talents) {
		const handleTalentsLogoClick = () => {
			if (pathname === "/talents") {
				scrollDocumentTop()
				return
			}
			navigate("/talents")
			requestAnimationFrame(() => {
				scrollDocumentTop()
			})
		}

		const handleTalentsLogin = () => {
			window.location.href = talentsSignInUrl
		}

		const handleTalentsJoin = () => {
			window.location.href = talentsSignupUrl
		}

		const TALENTS_NAV_LINKS = [
			{ href: "#find-work", label: "Find work" },
			{ href: "#build-profile", label: "Build profile" },
			{ href: "#how-it-works", label: "How it works" },
			{ href: "#meet-kate", label: "Meet Kate" },
			{ href: "#pricing", label: "Pricing" },
		]

		return (
			<>
				<div
					className={`${styles.navBackdrop} ${mobileOpen ? styles.navBackdropVisible : ""}`}
					aria-hidden
					onClick={closeMobile}
				/>

				{/* Talents mobile drawer */}
				<div
					className={`${styles.mobileDrawer} ${mobileOpen ? styles.mobileDrawerOpen : ""}`}
					aria-label="Mobile navigation"
					role="dialog"
					aria-modal="true"
				>
					<div className={styles.mobileDrawerHeader}>
						<button type="button" className={styles.navBrand} onClick={() => { closeMobile(); handleTalentsLogoClick() }} aria-label="Techcore for talents">
							<span className={styles.navLogoWrap}>
								<Logo />
							</span>
						</button>
						<button type="button" className={styles.mobileDrawerClose} onClick={closeMobile} aria-label="Close menu">
							<svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden>
								<path d="M4 4L14 14M14 4L4 14" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" />
							</svg>
						</button>
					</div>

					<nav className={styles.mobileDrawerNav} aria-label="Talents navigation">
						{TALENTS_NAV_LINKS.map((link) => (
							<a key={link.href} href={link.href} className={styles.mobileDrawerItem} onClick={closeMobile}>
								<span className={styles.mobileDrawerItemLabel}>{link.label}</span>
							</a>
						))}
					</nav>

					<div className={styles.mobileDrawerActions}>
						<button type="button" className={styles.mobileDrawerLogin} onClick={() => { closeMobile(); handleTalentsLogin() }}>
							Login
						</button>
						<button type="button" className={styles.mobileDrawerSignUp} onClick={() => { closeMobile(); handleTalentsJoin() }}>
							Join free
						</button>
					</div>
				</div>

				<header className={styles.navHris}>
					<div className={styles.navInner}>
						<button type="button" className={styles.navBrand} onClick={handleTalentsLogoClick} aria-label="Techcore for talents">
							<span className={styles.navLogoWrap}>
								<Logo />
							</span>
						</button>

						<nav className={styles.navTalentsNav} aria-label="Talents">
							{TALENTS_NAV_LINKS.map((link, i) => (
								<>
									{i > 0 && <span key={`sep-${i}`} className={styles.navTalentsSep} aria-hidden>|</span>}
									<a key={link.href} href={link.href} className={styles.navLinkPlain}>
										{link.label}
									</a>
								</>
							))}
						</nav>

						<div className={styles.navRight}>
							<button type="button" className={styles.navLogin} onClick={handleTalentsLogin}>
								Login
							</button>
							<button type="button" className={styles.navSignUpPrimary} onClick={handleTalentsJoin}>
								<span>Join free</span>
								<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
									<path
										d="M5.25 2.625L9.625 7L5.25 11.375"
										stroke="white"
										strokeWidth="1.5"
										strokeLinecap="round"
										strokeLinejoin="round"
									/>
								</svg>
							</button>
							<button
								type="button"
								className={styles.navHamburgerTalents}
								onClick={() => setMobileOpen((o) => !o)}
								aria-label={mobileOpen ? "Close menu" : "Open menu"}
								aria-expanded={mobileOpen}
							>
								{mobileOpen ? (
									<svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden>
										<path d="M4 4L14 14M14 4L4 14" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" />
									</svg>
								) : (
									<svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden>
										<path d="M3 5h14M3 10h14M3 15h14" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" />
									</svg>
								)}
							</button>
						</div>
					</div>
				</header>
			</>
		)
	}

	if (startups) {
		return (
			<div className={styles.header}>
				<div className={styles.leftSide}>
					<Logo onClick={handleLogoClick} />

					<button type="button" className={styles.pricing} onClick={handlePricingClick}>
						Pricing
					</button>
				</div>

				<div className={styles.rightSide}>
					<button className={styles.login} onClick={handleSignInClick}>
						Login
					</button>

					<button className={styles.signup} onClick={handleSignUpClick}>
						Sign Up
					</button>
				</div>
			</div>
		)
	}

	return (
		<>
			<div
				className={`${styles.navBackdrop} ${featuresOpen || mobileOpen ? styles.navBackdropVisible : ""}`}
				aria-hidden
				onClick={() => { closeFeatures(); closeMobile() }}
			/>

			{/* Mobile drawer */}
			<div
				className={`${styles.mobileDrawer} ${mobileOpen ? styles.mobileDrawerOpen : ""}`}
				aria-label="Mobile navigation"
				role="dialog"
				aria-modal="true"
			>
				<div className={styles.mobileDrawerHeader}>
					<button type="button" className={styles.navBrand} onClick={handleLogoClick} aria-label="Techcore home">
						<span className={styles.navLogoWrap}>
							<Logo />
						</span>
					</button>
					<button type="button" className={styles.mobileDrawerClose} onClick={closeMobile} aria-label="Close menu">
						<svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden>
							<path d="M4 4L14 14M14 4L4 14" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" />
						</svg>
					</button>
				</div>

				<nav className={styles.mobileDrawerNav} aria-label="Mobile main">
					<p className={styles.mobileDrawerSectionLabel}>Products</p>
					{PRODUCT_ITEMS.map((section) => {
						const IconCmp = FEATURE_ICONS[section.iconKey]
						return (
							<a
								key={section.id}
								href={section.href}
								className={styles.mobileDrawerItem}
								onClick={closeMobile}
							>
								<span className={`${styles.mobileDrawerItemIcon} ${styles[`fpIcon${section.iconKey}`]}`}>
									<IconCmp />
								</span>
								<span className={styles.mobileDrawerItemLabel}>{section.title}</span>
								<svg width="10" height="10" viewBox="0 0 10 10" fill="none" aria-hidden className={styles.mobileDrawerItemChevron}>
									<path d="M3.5 1.5L6.5 5L3.5 8.5" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
								</svg>
							</a>
						)
					})}

					<div className={styles.mobileDrawerDivider} />

					<Link to="/pricing" className={styles.mobileDrawerItem} onClick={closeMobile}>
						<span className={styles.mobileDrawerItemLabel}>Pricing</span>
					</Link>

					{!hideAudienceNav && (
						<>
							<div className={styles.mobileDrawerDivider} />
							<p className={styles.mobileDrawerSectionLabel}>Other audiences</p>
							<button type="button" className={styles.mobileDrawerItem} onClick={() => { closeMobile(); handleProvidersClick() }}>
								<span className={styles.mobileDrawerItemLabel}>For agencies</span>
								<ExternalIcon />
							</button>
							<button type="button" className={styles.mobileDrawerItem} onClick={() => { closeMobile(); handleHiringClick() }}>
								<span className={styles.mobileDrawerItemLabel}>For talents</span>
								<ExternalIcon />
							</button>
						</>
					)}
				</nav>

				<div className={styles.mobileDrawerActions}>
					<button type="button" className={styles.mobileDrawerLogin} onClick={() => { closeMobile(); handleSignInClick() }}>
						Login
					</button>
					<button type="button" className={styles.mobileDrawerSignUp} onClick={() => { closeMobile(); handleSignUpClick() }}>
						Sign Up
					</button>
				</div>
			</div>

			<header className={styles.navHris}>
				<div className={styles.navInner}>
					<button type="button" className={styles.navBrand} onClick={handleLogoClick} aria-label="Techcore home">
						<span className={styles.navLogoWrap}>
							<Logo />
						</span>
					</button>

					<nav className={styles.navLinks} aria-label="Main">
						<ul className={styles.navGroupLeft}>
							<li className={`${styles.navHasDropdown} ${featuresOpen ? styles.navHasDropdownOpen : ""}`}>
								<button
									type="button"
									className={styles.navDropdownTrigger}
									aria-expanded={featuresOpen}
									aria-controls="features-dropdown"
									aria-haspopup="true"
									onClick={(e) => {
										e.stopPropagation()
										setFeaturesOpen((o) => !o)
									}}
								>
									Products
									<ChevronIcon />
								</button>

								<div
									className={styles.navDropdown}
									id="features-dropdown"
									role="region"
									aria-label="Platform features"
									onClick={(e) => e.stopPropagation()}
								>
									{featuresOpen ? <FeaturesMegaMenu onCloseFeatures={closeFeatures} /> : null}
								</div>
							</li>

							<li>
								<Link to="/pricing" className={styles.navLinkPlain}>
									Pricing
								</Link>
							</li>
						</ul>
						{hideAudienceNav ? null : (
							<ul className={styles.navGroupRight}>
								<li>
									<button type="button" className={styles.navLinkAudience} onClick={handleProvidersClick}>
										For agencies
										<ExternalIcon />
									</button>
								</li>
								<li>
									<button type="button" className={styles.navLinkAudience} onClick={handleHiringClick}>
										For talents
										<ExternalIcon />
									</button>
								</li>
							</ul>
						)}
					</nav>

					<div className={styles.navRight}>
						<button type="button" className={styles.navLogin} onClick={handleSignInClick}>
							Login
						</button>
						<button type="button" className={styles.navSignUpPrimary} onClick={handleSignUpClick}>
							Sign Up
						</button>
						<button
							type="button"
							className={styles.navHamburger}
							onClick={() => setMobileOpen((o) => !o)}
							aria-label={mobileOpen ? "Close menu" : "Open menu"}
							aria-expanded={mobileOpen}
						>
							{mobileOpen ? (
								<svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden>
									<path d="M4 4L14 14M14 4L4 14" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" />
								</svg>
							) : (
								<svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden>
									<path d="M3 5h14M3 10h14M3 15h14" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" />
								</svg>
							)}
						</button>
					</div>
				</div>
			</header>
		</>
	)
}

export default Header
